var map = {
	"./de.json": 26876,
	"./empty.json": 36236,
	"./es.json": 41103,
	"./fr.json": 84411,
	"./it.json": 31942,
	"./ja.json": 79238,
	"./ko.json": 18765,
	"./lt.json": 78695,
	"./pt.json": 37003,
	"./ru.json": 59298,
	"./tr.json": 34237,
	"./zh.json": 43769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92623;